import { routes } from '../../constants/routes'

export type RootSubPage = {
  name: string
  icon: string
  path: string | string[]
}

export type RootPage = {
  name: string
  icon: string | null
  path: string | string[]
  submenu?: RootSubPage[]
}

export const menuBarList: RootPage[] = [
  {
    name: 'Home',
    icon: 'home',
    path: routes.HOME,
  },
  {
    name: 'Companies',
    icon: 'apartment',
    path: [routes.COMPANIES],
  },
  {
    name: 'Users',
    icon: 'people_alt',
    path: [routes.USERS],
  },
  {
    name: 'Trading',
    icon: null,
    path: routes.TRADING,
  },
  {
    name: 'Finance',
    icon: 'business_center',
    path: routes.FINANCE,
  },
  {
    name: 'Settings',
    icon: 'settings',
    path: [
      routes.SETTINGS_GENERAL,
      routes.SETTINGS_ADMIN_USERS,
      routes.SETTINGS_ASSETS,
      routes.SETTINGS_ENTITIES,
      routes.SETTINGS_RULES,
    ],
    submenu: [
      {
        name: 'General',
        icon: 'tune',
        path: routes.SETTINGS_GENERAL,
      },
      {
        name: 'Admin Users',
        icon: 'manage_accounts',
        path: routes.SETTINGS_ADMIN_USERS,
      },
      {
        name: 'Assets',
        icon: 'payments',
        path: routes.SETTINGS_ASSETS,
      },
      {
        name: 'Entity',
        icon: 'spa',
        path: routes.SETTINGS_ENTITIES,
      },
      {
        name: 'Rules',
        icon: 'manage_history',
        path: routes.SETTINGS_RULES,
      },
    ],
  },
]
